<div class="tab-content">
  <div class="q9-inline-section">
    <q9-section>
      <div title>{{'SIDEBAR.NODE_TITLE' | translate}}</div>
      <div content>{{ refModelNode.name}}</div>
    </q9-section>

    <q9-section *ngIf="refModelNode?.customId">
      <div title>{{'SIDEBAR.CUSTOM_ID' | translate}}</div>
      <div content>{{ refModelNode.customId}}</div>
    </q9-section>
  </div>

  <div class="q9-inline-section">
    <q9-section *ngIf="refModelNode?.description">
      <div title>{{'SIDEBAR.DESCRIPTION' | translate}}</div>
      <div content>{{ refModelNode.description}}</div>
    </q9-section>

    <q9-section *ngIf="refModelNode?.lastModifiedDate">
      <div title>{{'SIDEBAR.LAST_MOD' | translate}}</div>
      <div content>{{ refModelNode.lastModifiedDate | date}}</div>
    </q9-section>

    <q9-section *ngIf="refModelNode?.nodeDetails?.dashboardRefreshedDate">
      <div title>{{'SIDEBAR.LAST_REFRESHED' | translate}}</div>
      <div content>{{ refModelNode?.nodeDetails?.dashboardRefreshedDate | date}}</div>
    </q9-section>

    <q9-section *ngIf="refModelNode?.nodeDetails?.userLicense">
      <div title>{{'SIDEBAR.USER_LICENSE' | translate}}</div>
      <div content>{{ refModelNode?.nodeDetails?.userLicense}}</div>
    </q9-section>
  </div>

  <q9-section *ngIf="refModelNode?.createdDate">
    <div title>{{'SIDEBAR.CREATED_AT' | translate}}</div>
    <div content>{{ refModelNode.createdDate | date}}</div>
  </q9-section>
</div>
